import { type NavigationTypeType, keywordsObject } from "@quickpoint.me/shared";
import { useEffect } from "react";
import { useRecoilCallback, useRecoilValue } from "recoil";
import { NavigationType } from "../state/navigation";
import { PageIndex } from "../state/page";
import { ParsedCode } from "../state/selectors";

function FindMoveBy() {
	const pageIndex = useRecoilValue(PageIndex);
	const parsedCode = useRecoilValue(ParsedCode);

	const setNav = useRecoilCallback(({ set }) => (val: NavigationTypeType) => {
		set(NavigationType, val);
	});

	useEffect(() => {
		for (const [idx, page] of parsedCode.entries()) {
			for (const line of page) {
				if (
					line.type === keywordsObject["moveBy:"].keyword &&
					idx < pageIndex
				) {
					if (line.content === "scroll" || line.content === "tap") {
						setNav(line.content);
					}
				}
			}
		}
	});

	return <></>;
}

export default FindMoveBy;
